export const STANDARDS_TYPES__SYSTEM__LOADER = 'STANDARDS_TYPES__SYSTEM__LOADER';
export const ORGANIZATIONAL_UNIT__RISK_NOTE__LOADER = 'ORGANIZATIONAL_UNIT_RISK_NOTE';
export const FILE_DELETE__LOADER = 'FILE_DELETE__LOADER';
